import React from 'react';
import PropTypes from 'prop-types';

import { get } from 'dpl/shared/utils/object';
import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';

import MagazineHeaderNavigation from './MagazineHeaderNavigation';
import MagazineHeaderTitle from './MagazineHeaderTitle';

export default function MagazineHeader({ hub, sliceData }) {
  const title = get(hub, 'data.title', []);
  const navigation = get(sliceData, 'primary.navigation', {});

  return (
    <div className="PrismicMagazineHeader container">
      {navigation.id ? (
        <MagazineHeaderNavigation navigation={navigation} />
      ) : (
        <MagazineHeaderTitle title={title} />
      )}
    </div>
  );
}

MagazineHeader.propTypes = {
  hub: PropTypes.shape({
    data: PropTypes.shape({
      title: StructuredTextPropTypes.isRequired
    }).isRequired
  }).isRequired,
  sliceData: PropTypes.shape({
    primary: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      navigation: PropTypes.object
    })
  }).isRequired
};
